import React, { useEffect } from "react";
import './Modal.scss'

const Modal = ({ children, footer, onClose }) => {
    const handleBackdropClick = (e) => {
        if (e.target === e.currentTarget) {
            onClose?.();
        }
    };

    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === 'Escape') {
                onClose?.();
            }
        };
        document.addEventListener('keydown', handleKeyDown);
        return () => document.removeEventListener('keydown', handleKeyDown);
    }, [onClose]);

    return (
        <div className="modal" onClick={handleBackdropClick}>
            <div className="modal-content">
                {children}
                {footer && <div className="modal-actions">
                    {footer}
                </div>}
            </div>
        </div>
    );
};

export default Modal;
